import React, { useEffect } from 'react'

const HubSpotForm = () => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = '//js.hsforms.net/forms/embed/v2.js'
    script.async = true
    document.body.appendChild(script)

    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'na1',
          portalId: '45479371',
          formId: 'eecd2b93-b0bf-4ba7-8c70-8461a5016de5',
          target: '#hubspotForm'
        })
      }
    }

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return <div id="hubspotForm"></div>
}

export default HubSpotForm
